import { SEC_ApiCall, SEC_DataApiPost } from '../func';

/**
 * Validate a Reprographics permissions API response before the UI consumes it.
 */
function ensureValidResponse(response, validator) {
  if (!response || typeof response !== 'object') {
    throw new Error('Empty Reprographics permissions response');
  }
  if (typeof response.message === 'string' && response.message) {
    throw new Error(response.message);
  }
  if (!validator(response)) {
    throw new Error('Unexpected Reprographics permissions response shape');
  }
  return response;
}

/** Load all active staff and their editable Reprographics settings. */
export async function getReproStaffPermissions() {
  const response = await SEC_ApiCall('sysmanager/reprographics/access/staff');
  return ensureValidResponse(response, (payload) => Array.isArray(payload.items));
}

/** Update one access or assignment setting for one active staff member. */
export async function updateReproStaffPermission(payload) {
  const response = await SEC_DataApiPost(
    'sysmanager/reprographics/access/update',
    JSON.stringify(payload),
    {},
  );
  return ensureValidResponse(
    response,
    (responsePayload) => (
      typeof responsePayload.targetCogId === 'string'
      && responsePayload.reproPermissions
      && typeof responsePayload.reproPermissions === 'object'
      && responsePayload.reproAssignmentSettings
      && typeof responsePayload.reproAssignmentSettings === 'object'
    ),
  );
}
